import { useQuery } from '@tanstack/react-query';
import { LibraryEndpoint } from 'libs.react';
import { ApiClientService, useApiClient } from 'libs.react_internal';
export const useNotificationsLoader = (studyId) => {
    const libraryClient = useApiClient(ApiClientService.LIBRARY);
    const getTemplates = async () => {
        const { data: response } = await libraryClient.get(LibraryEndpoint.GET_TEMPLATES + `?public=true&studyId=${studyId}`);
        return response.data;
    };
    const { data: templates = [] } = useQuery({
        queryKey: ['templates'],
        queryFn: getTemplates,
    });
    // TODO: Only return templates being used by the study, i.e., being used by study notifications.
    return templates;
};
